<template>
    <span class="underline" :style="getStyle">
      <component :is="'jo' + item.name" v-for="item in data.data" v-bind:key="item.index" v-bind:data="item.data"></component>
    </span>
</template>

<script>
  export default {
    props: [
      'data'
    ],
    computed:{
      getStyle : function() {
         if(this.data.style == 'wave') {
             return { 'text-decoration-style':'wavy' }
         } else if(this.data.style == 'focus') {
             return { 'text-emphasis-style':'dot', 'text-emphasis-position':'under', 'text-decoration': 'none' }
         }
         return { 'text-decoration-style':this.data.style };
       }
    }
  }
</script>

<style>
  .underline {
    text-decoration-line: underline;
  }
</style>




// WEBPACK FOOTER //
// src/components/maincontent/body/common/underline.vue